import { apiFetch } from './client';

export interface Department {
  id: string;
  name: string;
}

export function listDepartments(): Promise<{ departments: Department[] }> {
  return apiFetch<{ departments: Department[] }>('/departments');
}

export function createDepartment(name: string): Promise<{ department: Department }> {
  return apiFetch<{ department: Department }>('/departments', {
    method: 'POST',
    body: JSON.stringify({ name }),
  });
}

export function updateDepartment(id: string, name: string): Promise<{ department: Department }> {
  return apiFetch<{ department: Department }>(`/departments/${id}`, {
    method: 'PUT',
    body: JSON.stringify({ name }),
  });
}

export function deleteDepartment(id: string): Promise<{ ok: boolean }> {
  return apiFetch<{ ok: boolean }>(`/departments/${id}`, { method: 'DELETE' });
}

export function getAgentDepartment(agentId: string): Promise<{ department: Department | null }> {
  return apiFetch<{ department: Department | null }>(`/agents/${agentId}/departments`);
}

export function setAgentDepartment(
  agentId: string,
  departmentId: string | null,
): Promise<{ ok: boolean; department: Department | null }> {
  return apiFetch<{ ok: boolean; department: Department | null }>(`/agents/${agentId}/departments`, {
    method: 'PUT',
    body: JSON.stringify({ departmentId }),
  });
}

export function setTicketDepartment(
  ticketId: string,
  departmentId: string,
): Promise<{ ok: boolean; department: Department }> {
  return apiFetch<{ ok: boolean; department: Department }>(`/tickets/${ticketId}/department`, {
    method: 'PUT',
    body: JSON.stringify({ departmentId }),
  });
}

export function clearTicketDepartment(ticketId: string): Promise<{ ok: boolean }> {
  return apiFetch<{ ok: boolean }>(`/tickets/${ticketId}/department`, { method: 'DELETE' });
}
